import {
  ErrorResponse as ER,
  ErrorResponseItem as ERI,
  NoticeOptions as NO,
} from '@/typings/api/ErrorResponse'
import { getErrorResponse } from './getErrorResponse'


interface ErrorObject {
  status?: number;
  code?: string;
  field?: string;
  message?: string;
  desc?: string;
  statusText?: string;
}

type EO = ErrorObject

export const getErrorMessages = (errorResponse: ER | EO | string, options: NO): string[] => {
  // @ts-ignore: тут все ок
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  const data = errorResponse?.data?.errors || errorResponse?.errors || errorResponse as ER['errors'] | string
  let errors: Array<ERI | EO> = []

  if (typeof data === 'string') {
    return [data]
  }

  if (typeof errorResponse === 'string') {
    return [errorResponse]
  }

  const errorCode = errorResponse?.code || errorResponse?.status

  if (Array.isArray(data)) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    errors = data
  } else if (!errorCode && 'message' in data) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    errors = [{ message: data.message }]
  }

  const code = errorResponse?.code || errorResponse?.status

  if (errors.length && code !== 403 && !options?.isUnknownErrorStructure) {
    return errors
      .map((_: EO | string) => {
        if (typeof _ === 'string') return _
        return [
          _.field as string,
          _.message || _.desc || _.statusText || '',
        ].filter(Boolean).join(': ')
      })
      .filter(Boolean)
  }

  if (data.isAxiosError) {
    const opt = getErrorResponse(errorCode)
    const errorMessage = (
      data?.desc
      || options?.message
      || `${opt.message || opt.label} (${opt.code})`
    )
    return [errorMessage]
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return [data?.message, data?.desc, options?.message].filter(Boolean) as [string]
}
